import styled from 'styled-components';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 950px;
  height: fit-content;
  max-height: 100%;
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  display: flex;
  flex-direction: column;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;

  span {
    display: inline-flex;
    cursor: pointer;
    border: 0;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border-radius: 8px;
    width: 32px;
    height: 32px;
    padding: 0;
    padding-top: 5px;

    transition: 0.2s;

    :hover {
      background-color: #f6f8ff;
    }
  }
`;

export const Title = styled.div`
  color: #1b203a;
  font-weight: 600;
  font-size: 1rem;
  line-height: 24px;
  flex: 1;
`;

export const ListItems = styled.ul`
  list-style: none;
  list-style-position: inside;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 22px;
  }

  ::-webkit-scrollbar-thumb {
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  &[data-list-type='disc'] {
    list-style-type: disc;
    margin-left: 16px;

    ul {
      margin-left: 16px;
    }
  }
`;

export const ListItem = styled.li`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #474d66;

  :not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const ListItemTitle = styled.h3`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #1b203a;
  margin: unset;
  margin-bottom: 8px;
`;

export const ListItemParagraph = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin: unset;
  color: #474d66;
`;

export const BoldText = styled.span`
  font-size: 14px;
  line-height: 22px;
  margin: unset;
  color: #474d66;
  font-weight: 700;
`;

export const NestedLists = styled.ol`
  list-style-position: inside;
  margin-left: 16px;

  ol {
    list-style-position: inside;
    margin-left: 16px;

    ol {
      list-style: lower-alpha;
      list-style-position: inside;
      margin-left: 16px;
    }
  }
`;

export const NestedList = styled.li`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #474d66;
`;
